import { clearStreamEnded } from '../utils/streamEnded';

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { logout, changeState, mudarProcesso } from '../actions/AppActions';
import { connect } from 'react-redux';

import moment from 'moment-timezone';
import { decrypt, URL } from '../variables';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Redacao from './Redacao';
import { Tab, Tabs } from 'react-bootstrap';
import { CircularProgress } from '@mui/material';

const DecideBorder = (resposta, correta, atual,prova) => {
    console.log(resposta,correta,atual)
    if(prova.prova?.show_acertos==true){
        if (atual == resposta && resposta == correta) {
            return '1px solid green';
        }
        else if (atual == resposta) {
            return '1px solid red';
        }
        else if (atual == correta) {
            return '1px solid green';
        }
        else {
            return '';
        }
    }
    else{
        if (atual == correta) {
            return '1px solid green';
        }
        else {
            return '';
        }
    }
}

class Finalizada extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',
            tab: 0,
            loading_finish:false

        };
        this.unmont_ = false;

    }


    componentDidMount() {
        this.props.changeStateParent({ show_face_mesh: false });
        try {

            if (this.props.stream != null) {
                console.log('finalizado stream4')

                clearStreamEnded(this.props.stream);
                this.props.stream.getTracks().map((track) => {
                    track.stop();
                })
            }
        }
        catch (e) {
            console.log(e)
        }
        try {

            if (this.props.stream_screen != null) {
                console.log('finalizado')
                clearStreamEnded(this.props.stream_screen);
                this.props.stream_screen.getTracks().map((track) => {

                    track.stop();
                })
            }
        }
        catch (e) {
            console.log(e)
        }

        this.props.changeState({ stream: null, stream_screen: null });
        // this.props.object_worker.terminate();
        if (this.props.processo.simulado == false) {
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, this.props.processo.save_timer_pre_exam);
        }
        else {
            this.logs_timeout = setTimeout(() => {
                localStorage.removeItem('token');
                this.props.logout();
            }, 30000);
        }

        this.props.provas.map((prova,id2)=>{
            if(prova.prova.type == 'multipla_escolha' && 
                prova.prova.folha_resposta == true && prova.prova.show_acertos == false && prova.prova.mirror == false
            ){
                this.download_answers(id2)
            }
        })
    }

    componentWillUnmount() {
        this.unmont_ = true;

        clearTimeout(this.logs_timeout);
    }

     async refazer_avaliacao() {
            this.setState({loading_finish:true});
    
            // this.aceitar_regras(this.canvas.current.toDataURL('image/jpeg',0.15));
            fetch(`${URL}api/refazer_avaliacao?v=a`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
    
                    'Authorization': `Bearer ${this.props.token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    processo_id: this.props.processo.id,
                })
            }).then(async (responseLog) => {
                try {
                    let resp = await responseLog.json();
                    resp = decrypt(resp);
    
                    console.log(resp);
                    if (resp.message == "Unauthenticated.") {
                        localStorage.removeItem('token');
                        // this.setState({redirect:true,path:'/'});
                        this.props.logout();
                    }
                    else {
                        this.setState({ loading_finish: false });
                        this.props.aceitar_regras(resp);
                    }
                } catch (err) {
                    this.setState({ loading_finish: false });
                    console.log(err);
    
    
                }
    
            })
                .catch((err) => {
                    this.setState({ loading_finish: false });
    
                    console.log(err);
                    // this.props.mudarLoadingHome(false);
                });
        }

    salvar_log() {
        fetch(`${URL}api/salvar_log?v=a`, {
            method: 'POST',
            body: JSON.stringify({ screen: 'finish', processo_id: this.props.processo.id, processo_name: this.props.processo.name }),
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);

                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && resp.processo.updated_at != this.props.processo.updated_at) {
                            this.props.mudarProcesso(resp.processo);
                        }
                        if (this.unmont_ == false) {

                            this.logs_timeout = setTimeout(() => {
                                this.salvar_log();
                            }, this.props.processo.save_timer_pre_exam);
                        }
                    }
                }
            } catch (err) {
                console.log(err);

                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            });
    }

    logout() {
        localStorage.removeItem('token');
        // this.setState({redirect:true,path:'/'});
        this.props.logout();
    }

    changeTab(k) {
        console.log(k)
        this.setState({ tab: k })
    }

    mapAlternative(alt){
        if (alt == null) {
            return '-';
        }
        if(alt.order==1){
            return 'a)'
        }
        else if(alt.order==2){
            return 'b)'
        }
        else if(alt.order==3){
            return 'c)'
        }
        else if(alt.order==4){
            return 'd)'
        }
        else if(alt.order==5){
            return 'e)'
        }
    }

    flattenObjectiveQuestions(prova) {
        const questions = [];
        if (prova == null || prova.questoes == null) {
            return questions;
        }

        prova.questoes.forEach((item) => {
            if (item.type_questao == 'simples') {
                questions.push(item);
            }
            else if (item.type_questao == 'conjunto' && item.questoes != null) {
                item.questoes.forEach((child) => questions.push(child));
            }
        });

        return questions;
    }

    getRespostaId(prova, questaoId) {
        if (prova == null || prova.respostas == null || prova.respostas[questaoId] == undefined) {
            return undefined;
        }

        const resposta = prova.respostas[questaoId];
        if (resposta != null && typeof resposta == 'object') {
            return resposta.alternativa_id;
        }

        return resposta;
    }

    getCorretaId(prova, questaoId) {
        if (prova == null || prova.corretas == null || prova.corretas[questaoId] == undefined) {
            return undefined;
        }

        const correta = prova.corretas[questaoId];
        if (correta != null && typeof correta == 'object') {
            return correta.alternativa_id;
        }

        return correta;
    }

    getAnswerLabel(question, respostaId) {
        if (respostaId == null || question == null || question.alternativas == null) {
            return '-';
        }

        const index = question.alternativas.findIndex((item) => item.id == respostaId);
        if (index < 0) {
            return '-';
        }

        return ['a)', 'b)', 'c)', 'd)', 'e)'][index] || '-';
    }

    isAnswerCorrect(prova, questaoId) {
        if (prova?.corretas_candidato != null && prova.corretas_candidato[questaoId] != undefined) {
            return prova.corretas_candidato[questaoId] == true;
        }

        const correta = this.getCorretaId(prova, questaoId);
        if (typeof correta == 'boolean') {
            return correta == true;
        }

        const resposta = this.getRespostaId(prova, questaoId);
        return correta != null && resposta != null && resposta == correta;
    }

    getAnswerMarker(prova, question) {
        if (prova?.prova?.show_acertos != true) {
            return '';
        }

        const respostaId = this.getRespostaId(prova, question?.id);
        if (question == null || respostaId == null) {
            return '';
        }

        return this.isAnswerCorrect(prova, question.id) ? 'C' : 'X';
    }

    getAnswerSheetRows(prova) {
        const showAnswer = prova?.prova?.folha_resposta == true;
        const showMarker = prova?.prova?.show_acertos == true;

        return this.flattenObjectiveQuestions(prova).map((question, index) => ({
            number: index + 1,
            answer: showAnswer ? this.getAnswerLabel(question, this.getRespostaId(prova, question.id)) : '',
            marker: showMarker ? this.getAnswerMarker(prova, question) : '',
        }));
    }
    getAnswerBoxStyle(width = 36) {
        return {
            border: '1px solid grey',
            width: width,
            minWidth: width,
            maxWidth: width,
            height: 30,
            textAlign: 'center',
            marginLeft: 0,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'black',
            fontWeight: 'bold',
            boxSizing: 'border-box',
        };
    }

    renderAnswerSheetCell(prova, question, number, showAnswer, width = 36, showMarker = true) {
        const respostaId = this.getRespostaId(prova, question.id);
        const label = showAnswer == true ? this.getAnswerLabel(question, respostaId) : '';
        const marker = showMarker == true ? this.getAnswerMarker(prova, question) : '';

        return (
            <div style={{ display: 'flex', width: width + 42, minWidth: width + 42, justifyContent: 'flex-start', alignItems: 'center', gap: 8 }}>
                <b style={{ width: 34, minWidth: 34, textAlign: 'right' }}>{number})</b>
                <div style={this.getAnswerBoxStyle(width)}>
                    {respostaId == undefined ? '-' : <>
                        {label != '-' && showAnswer == true ? label : ''}
                        {marker != '' && <span style={{ color: marker == 'C' ? 'green' : 'red', fontWeight: 'bold', marginLeft: label != '-' && showAnswer == true ? 2 : 0 }}>{marker}</span>}
                    </>}
                </div>
            </div>
        );
    }


    getTotalQuestions(prova) {
        return this.flattenObjectiveQuestions(prova).length;
    }

    getCorrectAnswersCount(prova) {
        if (prova?.corretas_candidato != null) {
            return Object.values(prova.corretas_candidato).filter((item) => item == true).length;
        }

        return this.flattenObjectiveQuestions(prova).filter((question) => this.isAnswerCorrect(prova, question.id)).length;
    }

    drawAnswerSheetPdf(doc, prova, rows) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 42;
        const title = prova.prova.show_acertos == true && prova.prova.folha_resposta == true
            ? 'Folha de resposta com relação de acertos/erros'
            : (prova.prova.show_acertos == true ? 'Relação de acertos/erros' : 'Folha com suas respostas');

        let y = 42;
        doc.setTextColor(20, 20, 20);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text(title, pageWidth / 2, y, { align: 'center' });

        y += 34;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(12);
        doc.text('Nome do Candidato: ' + this.props.user.name, margin, y);
        y += 20;
        if (this.props.user.numero_inscricao != null) {
            doc.text('Número de Inscrição: ' + this.props.user.numero_inscricao, margin, y);
            y += 20;
        }
        doc.text('Prova: ' + prova.prova.name, margin, y);
        y += 20;

        if (prova.prova.show_acertos == true) {
            doc.setFont('helvetica', 'bold');
            doc.text('Resultado: ' + this.getCorrectAnswersCount(prova) + '/' + this.getTotalQuestions(prova), margin, y);
            y += 20;
            doc.setFont('helvetica', 'normal');
            doc.text('C: Acertou   X: Errou   -: Sem resposta', margin, y);
            y += 22;
        }

        doc.setDrawColor(160, 160, 160);
        doc.line(margin, y, pageWidth - margin, y);
        y += 24;

        const columns = 4;
        const columnWidth = (pageWidth - margin * 2) / columns;
        const rowHeight = 30;
        const boxWidth = prova.prova.show_acertos == true ? 48 : 34;
        const boxHeight = 20;

        doc.setFontSize(12);
        let currentY = y;
        rows.forEach((item, index) => {
            const col = index % columns;
            if (col == 0 && index > 0) {
                currentY += rowHeight;
            }
            if (col == 0 && currentY + rowHeight > pageHeight - margin) {
                doc.addPage();
                currentY = margin;
            }

            const x = margin + col * columnWidth;
            const boxX = x + 28;
            const boxY = currentY - 14;
            const value = item.answer
                ? item.answer + (item.marker ? ' ' + item.marker : '')
                : (item.marker || '-');

            doc.setFont('helvetica', 'bold');
            doc.setTextColor(20, 20, 20);
            doc.text(item.number + ')', x, currentY);
            doc.rect(boxX, boxY, boxWidth, boxHeight);
            if (item.marker == 'C') {
                doc.setTextColor(0, 125, 0);
            }
            else if (item.marker == 'X') {
                doc.setTextColor(180, 0, 0);
            }
            else {
                doc.setTextColor(20, 20, 20);
            }
            doc.text(value, boxX + boxWidth / 2, currentY, { align: 'center' });
        });
    }

    htmlToText(html) {
        if (html == null) {
            return '';
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(String(html), 'text/html');
        return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    }

    ensurePdfSpace(doc, y, neededHeight, margin) {
        const pageHeight = doc.internal.pageSize.getHeight();
        if (y + neededHeight > pageHeight - margin) {
            doc.addPage();
            return margin;
        }
        return y;
    }

    drawPdfText(doc, text, x, y, maxWidth, options = {}) {
        const fontSize = options.fontSize || 11;
        const lineHeight = options.lineHeight || 15;
        doc.setFont('helvetica', options.bold == true ? 'bold' : 'normal');
        doc.setFontSize(fontSize);
        doc.setTextColor(options.color || 20, options.color || 20, options.color || 20);

        const lines = doc.splitTextToSize(text || '-', maxWidth);
        doc.text(lines, x, y);
        return y + lines.length * lineHeight;
    }

    drawQuestionBookPdf(doc, prova) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 36;
        const contentWidth = pageWidth - margin * 2;
        let y = margin;
        let number = 0;

        doc.setDrawColor(210, 210, 210);
        doc.setLineWidth(0.5);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(16);
        doc.text(prova.prova.name || 'Caderno de questões', margin, y);
        y += 22;

        if (prova.prova.show_acertos == true) {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);
            doc.text('Resultado: ' + this.getCorrectAnswersCount(prova) + '/' + this.getTotalQuestions(prova), margin, y);
            y += 18;
        }

        const drawQuestion = (question) => {
            number += 1;
            const questionText = this.htmlToText(question.name);
            const respostaId = this.getRespostaId(prova, question.id);
            const corretaId = this.getCorretaId(prova, question.id);
            const correctLabel = this.getAnswerLabel(question, corretaId);
            const answerLabel = this.getAnswerLabel(question, respostaId);
            const estimatedHeight = 86 + ((question.alternativas || []).length * 34);

            y = this.ensurePdfSpace(doc, y, Math.min(estimatedHeight, pageHeight - margin * 2), margin);
            if (y > margin) {
                doc.setDrawColor(220, 220, 220);
                doc.line(margin, y, pageWidth - margin, y);
                y += 16;
            }

            doc.setTextColor(20, 20, 20);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.text(number + ')', margin, y);
            y = this.drawPdfText(doc, questionText || ('Questão ' + number), margin + 34, y, contentWidth - 34, { fontSize: 12, lineHeight: 16 });
            y += 12;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text('Alternativas:', margin + 34, y);
            y += 18;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text('Correta: ' + correctLabel, margin + 34, y);
            y += 16;

            if (prova.prova.show_acertos == true) {
                doc.text('Respondida: ' + (answerLabel || '-'), margin + 34, y);
                y += 16;
            }

            (question.alternativas || []).forEach((alternativa, index) => {
                const label = ['a)', 'b)', 'c)', 'd)', 'e)'][index] || '';
                const altText = this.htmlToText(alternativa.name);
                const lines = doc.splitTextToSize(altText || '-', contentWidth - 82);
                const boxHeight = Math.max(26, lines.length * 14 + 10);
                y = this.ensurePdfSpace(doc, y, boxHeight + 8, margin);

                const isCorrect = corretaId != null && alternativa.id == corretaId;
                const isAnswered = respostaId != null && alternativa.id == respostaId;
                if (isCorrect || isAnswered) {
                    if (isCorrect) {
                        doc.setDrawColor(0, 150, 0);
                    } else {
                        doc.setDrawColor(220, 0, 0);
                    }
                    doc.rect(margin + 34, y - 8, contentWidth - 34, boxHeight);
                }

                doc.setTextColor(20, 20, 20);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(11);
                doc.text(label, margin + 38, y + 8);
                doc.text(lines, margin + 72, y + 8);
                y += boxHeight + 8;
            });
        };

        (prova.questoes || []).forEach((item) => {
            if (item.type_questao == 'simples') {
                drawQuestion(item);
            } else if (item.type_questao == 'conjunto') {
                y = this.ensurePdfSpace(doc, y, 60, margin);
                const groupText = this.htmlToText(item.name);
                if (groupText) {
                    y = this.drawPdfText(doc, groupText, margin, y, contentWidth, { fontSize: 11, lineHeight: 15, bold: true });
                    y += 10;
                }
                (item.questoes || []).forEach((child) => drawQuestion(child));
            }
        });
    }

    async downloadMirrorPdf(id2) {
        const prova = this.props.provas[id2];
        if (prova == null) {
            return;
        }

        const doc = new jsPDF('p', 'pt', 'a4');
        this.drawQuestionBookPdf(doc, prova);
        doc.save('caderno_' + this.props.processo.name.replace(/\./g, '') + '.pdf');
    }

    async download_answers(id2){
        const prova = this.props.provas[id2];
        if (prova?.prova?.mirror == true) {
            await this.downloadMirrorPdf(id2);
            return;
        }

        const doc = new jsPDF('p', 'pt', 'a4');
        this.drawAnswerSheetPdf(doc, prova, this.getAnswerSheetRows(prova));
        doc.save('suas_respostas_' + this.props.processo.name.replace(/\./g, '') + '.pdf');
    }

    getManualCorrectionTotal(correcao) {
        if (correcao == null) {
            return 0;
        }
        if (correcao.nota_final != null) {
            return correcao.nota_final;
        }
        return ['c1', 'c2', 'c3', 'c4', 'c5'].reduce((total, key) => total + (Number(correcao[key]) || 0), 0);
    }

    renderManualRedacaoCorrection(item) {
        const correcao = item.correcao_manual;
        if (item.redacao.show_correcao != true) {
            return null;
        }
        if (correcao == null || correcao.id == null) {
            return <p style={{fontSize:16,textAlign:'center'}}>Aguardando correção da redação...</p>;
        }

        return (
            <div style={{ marginTop: 20, color: 'black' }}>
                <h5 style={{ color: 'black', fontWeight: 700 }}>Correção da redação</h5>
                <div className="row" style={{ margin: 0 }}>
                    {['c1', 'c2', 'c3', 'c4', 'c5'].map((key, index) => (
                        <div key={key} className="col-12 col-md" style={{ padding: 6 }}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: 6, padding: 10, textAlign: 'center' }}>
                                <p style={{ margin: 0, fontWeight: 700 }}>C{index + 1}</p>
                                <p style={{ margin: 0 }}>{Number(correcao[key]) || 0}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <p style={{ fontSize: 18, fontWeight: 700, marginTop: 12 }}>Nota final: {this.getManualCorrectionTotal(correcao)}</p>
                {correcao.comentario != null && correcao.comentario != '' && <p style={{ whiteSpace: 'pre-line' }}><b>Comentário: </b>{correcao.comentario}</p>}
            </div>
        );
    }

    render() {
        let index = 0;

        return (
            <div >

                <hr />
                <div className="text-success"
                    style={{ padding: '5px 5px 5px 5px', fontWeight: 'bold', fontSize: '1.4rem', textAlign: 'center' }}>
                    Avaliação finalizada com sucesso
                </div>
                {/* <hr/> */}

                <br />
                <br />
                {(this.props.provas?.length != 0 ) && <div>

                    <h5 style={{ color: 'black', fontWeight: 600 }}>Respostas:</h5>
                </div>}
                <Tabs
                    id="controlled-tab-example"
                    activeKey={this.state.tab}
                    onSelect={(k) => {
                        if (this.props.processo.exam_per_time == false) {
                            this.changeTab(k);
                        }
                    }}
                >

                    {/* {this.props.provas.filter((item, id) => item.prova.folha_resposta == true).length != 0 && this.props.provas != null && this.props.provas.length > 0 && this.props.processo_resultado != null && this.props.processo_resultado.gabarito == false && }

                    {this.props.provas.filter((item, id) => item.prova.folha_resposta == true).length != 0 && this.props.provas != null && this.props.provas.length > 0 && this.props.processo_resultado != null && this.props.processo_resultado.gabarito == false && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>

                    </div>} */}



                    {/* {this.props.provas.filter((item, id) => item.prova.show_acertos == true).length != 0 && this.props.provas != null && this.props.provas.length > 0 && this.props.processo_resultado != null && this.props.processo_resultado.gabarito == false && <div>
                        <hr />

                        <h5 style={{ color: 'black', fontWeight: 600 }}>Relação de acerto/erros</h5>
                        <p style={{ color: 'black', fontSize: '1rem', marginBottom: '2.2rem' }}>A relação de acertos/erros será exibido apenas uma vez. Após sair ou atualizar a página, não será possível baixá-la novamente.</p>
                    </div>} */}
                    {/* {this.props.provas.filter((item, id) => item.prova.show_acertos == true).length != 0 && this.props.provas != null && this.props.provas.length > 0 && this.props.processo_resultado != null && this.props.processo_resultado.gabarito == false && <div id="resultados_2"> */}


                    {this.props.provas.map((prova, id2) => {
                        if (prova.prova.type == 'multipla_escolha') {
                            let number_questao = 0;
                            if (prova.prova.mirror != true && prova.prova.show_acertos == true && prova.prova.folha_resposta == true ) {
                                index += 1;

                                return (
                                    <Tab tabClassName={'tab'} key={id2} eventKey={index - 1} title={prova.prova.name}>
                                        <div id={"resultados_" + id2}>

                                        <br />
                                        <br />
                                        <div className="row d-flex justify-content-center mr-2" style={{ float: 'right' }}>

                                            <img src={this.props.faculdade.logo} alt="" height='60' style={{ height: 40, objectFit: 'contain' }} />
                                        </div>
                                        <h5 style={{ textAlign: 'center', fontWeight: 600 }}>
                                            Folha de resposta com Relação de acerto/erros</h5>
                                        <p style={{ textAlign: 'justify', marginBottom: 0 }}>Nome do Candidato: {this.props.user.name}</p>
                                        {this.props.user.numero_inscricao != null && <p style={{ textAlign: 'justify', marginBottom: 0 }}>Número de Inscrição: {this.props.user.numero_inscricao}</p>}
                                        <div className='mt-2 mb-2' style={{ marginLeft: 0, marginRight: 0 }}>
                                            <div style={{ color: 'black', width: 'auto' }}>
                                                <i style={{ color: 'green' }} >C</i>: Acertou
                                            </div>
                                            <div style={{ color: 'black', width: 'auto' }}>

                                                <i style={{ color: 'red' }} >X</i>: Errou
                                            </div>

                                            <div style={{ color: 'black', width: 'auto' }}>

                                                <span>--  : Sem resposta</span>
                                            </div>
                                        </div>
                                        <hr />
                                        <div >
                                            <div key={id2} className="row">

                                                <div className="col-12">
                                                    <p style={{ letterSpacing: 0.2, textAlign: 'justify', marginBottom: 0, whiteSpace: 'pre-line' }}><b>Prova: </b> {prova.prova.name}</p>
                                                    <p style={{ letterSpacing: 0.2, textAlign: 'justify', marginBottom: 0, whiteSpace: 'pre-line' }}><b>Resultado: </b> {this.getCorrectAnswersCount(prova)}/{this.getTotalQuestions(prova)}</p>

                                                    <br />
                                                    <div className="row">

                                                        {prova.questoes.map((item, id) => {
                                                            if (item.type_questao == 'simples' || item.type_questao == 'dissertativa') {
                                                                number_questao = number_questao + 1;
                                                            }
                                                            if (item.type_questao == 'simples') {

                                                                return (
                                                                    <div key={id} style={{ marginTop: '10px', paddingLeft: 15, paddingRight: 15, width: 'auto' }}>

                                                                        <a  >
                                                                            {this.renderAnswerSheetCell(prova, item, number_questao, true, 65)}

                                                                        </a>
                                                                    </div>
                                                                )
                                                            }
                                                            else if (item.type_questao == 'conjunto') {
                                                                return (
                                                                    item.questoes.map((item3, id3) => {
                                                                        number_questao = number_questao + 1;
                                                                        return (
                                                                            <div key={id3} style={{ marginTop: '10px', paddingLeft: 15, paddingRight: 15, width: 'auto' }}>

                                                                                <a  >
                                                                                    {this.renderAnswerSheetCell(prova, item3, number_questao, true, 65)}

                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })
                                                                )
                                                            }


                                                        })}



                                                    </div>
                                                    <hr />
                                                </div>


                                            </div >
                                        </div>
                                       
                                        </div>
                                        {prova.prova.allow_result_download == true && <button className="btn btn-info btn-lg" onClick={async () => {
                                                this.download_answers(id2);

                                            }} style={{ width: '100%' }}><i
                                                className="mdi mdi-download" style={{ color: 'white' }}></i> Baixar folha com suas respostas</button>}

                                    </Tab>
                                )
                            }
                            else if (prova.prova.mirror != true && prova.prova.show_acertos == true) {
                                index += 1;

                                return (
                                    <Tab tabClassName={'tab'} key={id2} eventKey={index - 1} title={prova.prova.name}>
                                        <br />
                                        <br />
                                        <div className="row d-flex justify-content-center mr-2" style={{ float: 'right' }}>

                                            <img src={this.props.faculdade.logo} alt="" height='60' style={{ height: 40, objectFit: 'contain' }} />
                                        </div>
                                        <h5 style={{ textAlign: 'center', fontWeight: 600 }}>
                                            Relação de acerto/erros</h5>
                                        <p style={{ textAlign: 'justify', marginBottom: 0 }}>Nome do Candidato: {this.props.user.name}</p>
                                        {this.props.user.numero_inscricao != null && <p style={{ textAlign: 'justify', marginBottom: 0 }}>Número de Inscrição: {this.props.user.numero_inscricao}</p>}
                                        <div className='mt-2 mb-2' style={{ marginLeft: 0, marginRight: 0 }}>
                                            <div style={{ color: 'black', width: 'auto' }}>
                                                <span style={{ color: 'green', fontWeight: 'bold' }}>C</span>: Acertou
                                            </div>
                                            <div style={{ color: 'black', width: 'auto' }}>

                                                <span style={{ color: 'red', fontWeight: 'bold' }}>X</span>: Errou
                                            </div>

                                            <div style={{ color: 'black', width: 'auto' }}>

                                                <span>--  : Sem resposta</span>
                                            </div>
                                        </div>
                                        <hr />
                                        <div id={"resultados_" + id2}>
                                            <div key={id2} className="row">

                                                <div className="col-12">
                                                    <p style={{ letterSpacing: 0.2, textAlign: 'justify', marginBottom: 0, whiteSpace: 'pre-line' }}><b>Prova: </b> {prova.prova.name}</p>
                                                    <p style={{ letterSpacing: 0.2, textAlign: 'justify', marginBottom: 0, whiteSpace: 'pre-line' }}><b>Resultado: </b> {this.getCorrectAnswersCount(prova)}/{this.getTotalQuestions(prova)}</p>

                                                    <br />
                                                    <div className="row">

                                                        {prova.questoes.map((item, id) => {
                                                            if (item.type_questao == 'simples' || item.type_questao == 'dissertativa') {
                                                                number_questao = number_questao + 1;
                                                            }
                                                            if (item.type_questao == 'simples') {

                                                                return (
                                                                    <div key={id} style={{ marginTop: '10px', paddingLeft: 15, paddingRight: 15, width: 'auto' }}>

                                                                        <a  >
                                                                            {this.renderAnswerSheetCell(prova, item, number_questao, false, 36)}

                                                                        </a>
                                                                    </div>
                                                                )
                                                            }
                                                            else if (item.type_questao == 'conjunto') {
                                                                return (
                                                                    item.questoes.map((item3, id3) => {
                                                                        number_questao = number_questao + 1;
                                                                        return (
                                                                            <div key={id3} style={{ marginTop: '10px', paddingLeft: 15, paddingRight: 15, width: 'auto' }}>

                                                                                <a  >
                                                                                    {this.renderAnswerSheetCell(prova, item3, number_questao, false, 36)}

                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })
                                                                )
                                                            }


                                                        })}



                                                    </div>
                                                    <hr />
                                                </div>


                                            </div >
                                        </div>
                                        {prova.prova.allow_result_download == true && <button className="btn btn-info btn-lg" onClick={async () => {
                                            this.download_answers(id2);
                                        }} style={{ width: '100%' }}><i
                                            className="mdi mdi-download" style={{ color: 'white' }}></i> Baixar relação de acertos/erros</button>}
                                    </Tab>
                                )
                            }
                            else if (prova.prova.type == 'multipla_escolha') {
                                let number_questao = 0;
                                index += 1;

                                if (prova.prova.folha_resposta == true && prova.prova.mirror == false) {
                                    return (
                                        <Tab tabClassName={'tab'} key={id2} eventKey={index - 1} title={prova.prova.name}>
                                            <br />
                                            <br />

                                            <div id={"resultados_" + id2}>
                                                <div className="row d-flex justify-content-center mr-2" style={{ float: 'right' }}>

                                                    <img src={this.props.faculdade.logo} alt="" height='60' style={{ height: 40, objectFit: 'contain' }} />
                                                </div>
                                                <h5 style={{ textAlign: 'center', fontWeight: 600 }}>
                                                    Folha com suas respostas</h5>
                                                <p style={{ textAlign: 'justify', marginBottom: 0 }}>Nome do Candidato: {this.props.user.name}</p>
                                                {this.props.user.numero_inscricao != null && <p style={{ textAlign: 'justify', marginBottom: 0 }}>Número de Inscrição: {this.props.user.numero_inscricao}</p>}

                                                {this.props.provas.map((prova, id2) => {

                                                })}
                                                <div key={id2} className="row">

                                                    <div className="col-12">
                                                        <p style={{ letterSpacing: 0.2, textAlign: 'justify', marginBottom: 0, whiteSpace: 'pre-line' }}><b>Prova: </b> {prova.prova.name}</p>
                                                        <br />
                                                        <div className="row">

                                                            {prova.questoes.map((item, id) => {
                                                                if (item.type_questao == 'simples' || item.type_questao == 'dissertativa') {
                                                                    number_questao = number_questao + 1;
                                                                }
                                                                if (item.type_questao == 'simples') {

                                                                    return (
                                                                        <div key={id} style={{ marginTop: '10px', paddingLeft: 15, paddingRight: 15, width: 'auto' }}>

                                                                            <a  >
                                                                                {this.renderAnswerSheetCell(prova, item, number_questao, true, 36, false)}

                                                                            </a>
                                                                        </div>
                                                                    )
                                                                }
                                                                else if (item.type_questao == 'conjunto') {
                                                                    return (
                                                                        item.questoes.map((item3, id3) => {
                                                                            number_questao = number_questao + 1;
                                                                            return (
                                                                                <div key={id3} style={{ marginTop: '10px', paddingLeft: 15, paddingRight: 15, width: 'auto' }}>

                                                                                    <a  >
                                                                                        {this.renderAnswerSheetCell(prova, item3, number_questao, true, 36, false)}

                                                                                    </a>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    )
                                                                }


                                                            })}



                                                        </div>
                                                        <hr />
                                                    </div>


                                                </div >
                                            </div>

                                            {prova.prova.allow_result_download == true && <button className="btn btn-info btn-lg" onClick={async () => {
                                                this.download_answers(id2);

                                            }} style={{ width: '100%' }}><i
                                                className="mdi mdi-download" style={{ color: 'white' }}></i> Baixar folha com suas respostas</button>}

                                        </Tab>

                                    )
                                }
                                else if (prova.prova.folha_resposta == true && prova.prova.mirror == true) {
                                    console.log('aqui')
                                    console.log(prova)
                                    return (
                                        <Tab tabClassName={'tab'} key={id2} eventKey={index - 1} title={prova.prova.name}>
                                            {prova.prova.show_acertos==true && <p style={{ letterSpacing: 0.2, textAlign: 'justify', marginBottom: 0,marginTop:10, whiteSpace: 'pre-line' }}><b>Resultado: </b> {this.getCorrectAnswersCount(prova)}/{this.getTotalQuestions(prova)}</p>}
                                        <div id={'resultados_' + id2} key={id2}>
                                            {prova.questoes != null && prova.questoes.map((item, id3) => {
                                                console.log(item)
                                                if (item.type_questao == 'simples' || item.type_questao == 'dissertativa') {
                                                    number_questao = number_questao + 1;
                                                }
                                                return (
                                                    <div key={id3}>
                                                        <hr />

                                                        {prova.prova.hide_category != true && <h6 className="mt-0 header-title" style={{ textAlign: 'right', marginBottom: 10, fontSize: 15 }}>
                                                            {item.categoria.name}</h6>
                                                        }
                                                        {item.type_questao == 'dissertativa' && <div className="row" style={{ fontWeight: 'normal', margin: 0, margin: 0 }}>
                                                            <div className="col-2 col-sm-1">
                                                                <h5 style={{ textAlign: 'justify', color: 'black', marginTop: 0 }}>
                                                                    <b>{number_questao})</b></h5>
                                                            </div>
                                                            <div className="col-10 col-sm-11">


                                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.name }}>

                                                                </div>
                                                                {prova.prova.show_acertos==true && <>
                                                                    <p><b>Resposta: </b></p>
                                                                    <p style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>
                                                                        {this.getRespostaId(prova, item.id) != undefined ? this.getRespostaId(prova, item.id) : '-'}
                                                                    </p>
                                                                </>}

                                                            </div>
                                                        </div>}
                                                        {/* {!!Form::open(['action' =>
['ProcessoUserController@responder_questao'],'data-toggle'=>'validator','files' =>
false,'method'=>'post','id'=>$data['prova']->id.'_'.$questao->id]) !!} */}
                                                        {console.log('aquiiiiiiii')}

                                                        {item.type_questao == 'simples' && <div className="row" style={{ fontWeight: 'normal', margin: 0 }}>
                                                            <div className="col-2 col-sm-1">
                                                                <h5 style={{ textAlign: 'justify', color: 'black', marginTop: 0 }}>
                                                                    <b>{number_questao})</b></h5>
                                                            </div>
                                                            <div className="col-10 col-sm-11">


                                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.name }}>

                                                                </div>
                                                                <p><b>Alternativas:</b></p>
                                                                <p><b>Correta: </b>{this.mapAlternative(item.alternativas.filter((item5)=>item5.id==this.getCorretaId(prova, item.id))[0])}</p>
                                                                {prova.prova.show_acertos==true && <>
                                                                    <p><b>Respondida: </b>{this.getRespostaId(prova, item.id) != undefined ? this.mapAlternative(item.alternativas.filter((item5)=>item5.id==this.getRespostaId(prova, item.id))[0]) : '-'}</p>
                                                                </>}

                                                                <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item.id) != undefined ? this.getRespostaId(prova, item.id) : '-', this.getCorretaId(prova, item.id),item.alternativas[0].id,prova ) }}>
                                                                    <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                        <p style={{ color: 'black', fontWeight: 'normal' }}>a)</p>
                                                                    </div>
                                                                    <div style={{ width: '90%' }}>

                                                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[0].name }}>

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                {item.alternativas[1] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item.id) != undefined ? this.getRespostaId(prova, item.id) : '-',  this.getCorretaId(prova, item.id),item.alternativas[1].id,prova ) }}>
                                                                    <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                        <p style={{ color: 'black', fontWeight: 'normal' }}>b)</p>
                                                                    </div>
                                                                    <div style={{ width: '90%' }}>

                                                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[1].name }}>

                                                                        </div>
                                                                    </div>

                                                                </div>}
                                                                {item.alternativas[2] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item.id) != undefined ? this.getRespostaId(prova, item.id) : '-',  this.getCorretaId(prova, item.id),item.alternativas[2].id,prova ) }}>
                                                                    <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                        <p style={{ color: 'black', fontWeight: 'normal' }}>c)</p>
                                                                    </div>
                                                                    <div style={{ width: '90%' }}>

                                                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[2].name }}>

                                                                        </div>
                                                                    </div>

                                                                </div>}
                                                                {item.alternativas[3] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item.id) != undefined ? this.getRespostaId(prova, item.id) : '-',  this.getCorretaId(prova, item.id),item.alternativas[3].id,prova ) }}>
                                                                    <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                        <p style={{ color: 'black', fontWeight: 'normal' }}>d)</p>
                                                                    </div>
                                                                    <div style={{ width: '90%' }}>

                                                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[3].name }}>

                                                                        </div>
                                                                    </div>

                                                                </div>}

                                                                {item.alternativas[4] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item.id) != undefined ? this.getRespostaId(prova, item.id) : '-',  this.getCorretaId(prova, item.id),item.alternativas[4].id,prova ) }}>
                                                                    <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                        <p style={{ color: 'black', fontWeight: 'normal' }}>e)</p>
                                                                    </div>
                                                                    <div style={{ width: '90%' }}>

                                                                        <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.alternativas[4].name }}>

                                                                        </div>
                                                                    </div>

                                                                </div>}
                                                            </div>
                                                        </div>}





                                                        {item.type_questao == 'conjunto' && <div className="row" style={{ fontWeight: 'normal', margin: 0 }}>

                                                            <div className="col-12 col-sm-12">


                                                                <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item.name }}>

                                                                </div>
                                                                {item.questoes.map((item2, id2) => {
                                                                    number_questao = number_questao + 1;

                                                                    return (<div key={id2} className="row" style={{ fontWeight: 'normal', margin: 0 }}>
                                                                        <div className="col-2 col-sm-1">
                                                                            <h5 style={{ textAlign: 'justify', color: 'black', marginTop: 0 }}>
                                                                                <b>{number_questao})</b></h5>
                                                                        </div>
                                                                        <div className="col-10 col-sm-11">


                                                                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.name }}>

                                                                            </div>
                                                                            <p><b>Alternativas:</b></p>
                                                                            {/* <p><b>Correta: </b>{item2.correta}</p> */}
                                                                            <p><b>Correta: </b>{this.mapAlternative(item2.alternativas.filter((item5)=>item5.id==this.getCorretaId(prova, item2.id))[0])}</p>

                                                                            {prova.prova.show_acertos==true && <>
                                                                                <p><b>Respondida: </b>{this.getRespostaId(prova, item2.id) != undefined ? this.mapAlternative(item2.alternativas.filter((item5)=>item5.id==this.getRespostaId(prova, item2.id))[0]) : '-'}</p>
                                                                                {/* <p><b>Respondida: </b>{this.getRespostaId(prova, item2.id) != undefined ? this.getRespostaId(prova, item2.id) : '-'}</p> */}
                                                                            </>}

                                                                            <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item2.id) != undefined ? this.getRespostaId(prova, item2.id) : '-',  this.getCorretaId(prova, item2.id),item2.alternativas[0].id,prova )}}>
                                                                                <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                                    <p style={{ color: 'black', fontWeight: 'normal' }}>a)</p>
                                                                                </div>
                                                                                <div style={{ width: '90%' }}>

                                                                                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[0].name }}>

                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                            {item2.alternativas[1] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item2.id) != undefined ? this.getRespostaId(prova, item2.id) : '-',  this.getCorretaId(prova, item2.id),item2.alternativas[1].id,prova ) }}>
                                                                                <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                                    <p style={{ color: 'black', fontWeight: 'normal' }}>b)</p>
                                                                                </div>
                                                                                <div style={{ width: '90%' }}>

                                                                                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[1].name }}>

                                                                                    </div>
                                                                                </div>

                                                                            </div>}
                                                                            {item2.alternativas[2] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item2.id) != undefined ? this.getRespostaId(prova, item2.id) : '-',  this.getCorretaId(prova, item2.id),item2.alternativas[2].id,prova ) }}>
                                                                                <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                                    <p style={{ color: 'black', fontWeight: 'normal' }}>c)</p>
                                                                                </div>
                                                                                <div style={{ width: '90%' }}>

                                                                                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[2].name }}>

                                                                                    </div>
                                                                                </div>

                                                                            </div>}
                                                                            {item2.alternativas[3] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item2.id) != undefined ? this.getRespostaId(prova, item2.id) : '-',  this.getCorretaId(prova, item2.id),item2.alternativas[3].id,prova ) }}>
                                                                                <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                                    <p style={{ color: 'black', fontWeight: 'normal' }}>d)</p>
                                                                                </div>
                                                                                <div style={{ width: '90%' }}>

                                                                                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[3].name }}>

                                                                                    </div>
                                                                                </div>

                                                                            </div>}

                                                                            {item2.alternativas[4] != undefined && <div style={{ display: 'flex', marginTop: 10, border: DecideBorder(this.getRespostaId(prova, item2.id) != undefined ? this.getRespostaId(prova, item2.id) : '-',  this.getCorretaId(prova, item2.id),item2.alternativas[4].id,prova ) }}>
                                                                                <div style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                                                    <p style={{ color: 'black', fontWeight: 'normal' }}>e)</p>
                                                                                </div>
                                                                                <div style={{ width: '90%' }}>

                                                                                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: item2.alternativas[4].name }}>

                                                                                    </div>
                                                                                </div>

                                                                            </div>}
                                                                        </div>
                                                                    </div>)
                                                                })}

                                                            </div>
                                                        </div>}
                                                    </div>

                                                )
                                            })}
                                        </div>
                                        {prova.prova.allow_result_download == true && <button className="btn btn-info btn-lg" onClick={async () => {
                                            this.download_answers(id2);
                                        }} style={{ width: '100%', marginTop: 16 }}><i
                                            className="mdi mdi-download" style={{ color: 'white' }}></i> Baixar caderno de questões</button>}
                                        </Tab>
                                    )
                                }
                            }
                        }
                    })}
                    {/* </div>} */}

                    {this.props.redacoes?.map((item, id2) => {
                        index += 1;
                        return (
                            <Tab tabClassName={'tab'} key={id2} eventKey={index - 1}
                                title={item.redacao.name}>
                                     <br />
                                <br />
                            {item.redacao.resultado_ia == true && <>
                                {item.correcao?.id!=null ? <>
                                    <p style={{fontSize:16}}><b>{item.redacao.name}</b></p>
                                    <p style={{whiteSpace:'pre-line'}}><b>Resumo: </b>
                                    {item.correcao.competencia_1}
                                    </p>
                                    <p><b>Situação: </b>
                                    <span style={{color:item.correcao.nota>=4?'green':'red'}}>{item.correcao.nota>4?'Aprovado':'Você não atingiu a nota mínima. Tente novamente cliando no botão "Refazer redação"'}</span>
                                    </p>
                                    {item.correcao.nota<4 && this.props.processo.finish_time==false && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
                                        {this.state.loading_finish==false? <button className="btn btn-info btn-lg" onClick={()=>{
                                            this.refazer_avaliacao();
                                        }} style={{ width: '100%' }}><i
                                            className="mdi mdi-reload" style={{ color: 'white' }}></i> Refazer redação</button>
                                        :<CircularProgress/>
                                        }

                                    </div>}
                                </>:
                                    <p style={{fontSize:16,textAlign:'center'}}>Aguardando correção...</p>}
                            </>}

                            {item.redacao.folha_resposta == true && <Redacao
                                show_answer={true}
                                finishExam={() => { }}

                                changeTab={(k) => {
                                    // this.changeTab(k);
                                }}
                                indice={id2} index={id2} />
                            }

                            {this.renderManualRedacaoCorrection(item)}
                           </Tab>
                        );

                    })}
                </Tabs>



                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '1rem' }}>
                    <button className="btn btn-success btn-lg" onClick={this.logout.bind(this)} style={{ width: '100%' }}><i
                        className="mdi mdi-power" style={{ color: 'white' }}></i> Clique aqui para Sair</button>

                </div>

            </div>

        );
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        token: state.AppReducer.token,
        user: state.AppReducer.user,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,


        // object_worker: state.AppReducer.object_worker,

        faculdade: state.AppReducer.faculdade,
        processo_resultado: state.AppReducer.processo_resultado,



    }
);

export default withRouter(connect(mapsStateToProps, { logout, changeState, mudarProcesso })(Finalizada));
